import { default as Tabs } from 'antd/es/tabs';
import { default as Skeleton } from 'antd/es/skeleton';
import { useState, useEffect } from 'react';

import { prettifyJson } from '../utils/prettifyJson';

import { Resource } from '../components/Resource';
import { PrismCode } from '../components/PrismCode';
import { CUSTOM_TAB_STYLE } from '../useCustomAntdTheme';

export function WebhooksPage({ url }: { url: string }) {
  const [responses, setResponses] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<Error | null>(null);
  const [resourceFile, setResourceFile] = useState<any>(undefined);

  useEffect(() => {
    const loadWebhooks = async () => {
      try {
        setLoading(true);
        const module = await import(`../data/${url}.json`);
        setResponses(module.paths.webhooks.GET.response);
        setResourceFile(module.paths.webhooks.GET.summary);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    loadWebhooks();
  }, [url]);

  if (loading) {
    return <Skeleton active />;
  }

  if (error) {
    return <h3>Error loading</h3>;
  }

  const tabItems = responses.examples.map((example: any, index: any) => {
    return {
      key: index.toString(),
      label: example.state ?? example.status,
      children: (
        <PrismCode
          showClipboard
          language="js"
          code={prettifyJson(example)}
          withRadius={false}
        />
      )
    };
  });

  return (
    <div className="raw flex flex-col gap-4">
      <div className="flex flex-row gap-12">
        <div className="flex-1 flex-col whitespace-pre-line">
          <Resource resource={{ filePath: resourceFile }} />
        </div>

        <div className="flex w-1/2 flex-1 flex-col gap-5">
          <Tabs items={tabItems} style={CUSTOM_TAB_STYLE} />
          <div className="flex flex-1 flex-col ">
            <PrismCode
              title="Returns"
              code={String(responses.parameters.map((x: any) => x.description))}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
